export const EqualizeFilesMysql = (files, mysql) => {
    let tables = [];
    let compare = [];
    let diff = [];
    mysql.map((item) => tables.push(item.Tables_in_disneylandparis));
    diff = files.filter((e) => !tables.includes(e));
    files.map((file, i) => compare.push({ files: file, mysql: tables[i] }));
    return [compare, diff];
}